import { usePayment } from 'publisher/store'
import paymentSelectors from 'publisher/store/payment/paymentSelectors'
import React from 'react'
import BaseFieldNew from 'src/publisher/entities/field-new/base-field'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'

type CompanyNameFieldProps = {
  entity: FieldEntityInterface
}

function CompanyNameFieldNew({ entity }: CompanyNameFieldProps) {
  const isPersonal = usePayment(paymentSelectors.isCustomerPersonal)

  return isPersonal ? (
    <div />
  ) : (
    <BaseFieldNew entity={entity} needInitialise={false} />
  )
}

export default CompanyNameFieldNew
